import { Stack } from '@mui/system';
import { Button, Tooltip, useTheme } from '@mui/material';
import React from 'react';
import { InfoOutlined, LockRounded, SwapHorizRounded, UndoRounded } from '@mui/icons-material';

function ReplacementOptimizationActions({ locked, status, handleReviewReplacement }) {
    const theme = useTheme();

    if (locked) {
        return (
            <Stack direction='row-reverse' alignItems='center' justifyContent='space-between'>
                <Tooltip enterTouchDelay={0} title='Any card edits you accept in this dashboard are automatically submitted to your card management team for review, approval, and implementation within 24 hours. This card edit is currently under review by your card management team.'>
                    <InfoOutlined style={{ color: `${theme.palette.blue.main}`, marginRight: '8px', position: 'absolute' }} />
                </Tooltip>
                <Button variant='text' startIcon={<LockRounded />} disabled fullWidth>
                    Pending Card Manager Review
                </Button>
            </Stack>
        );
    }

    const isOpen = status === 'open';

    return (
        <Stack px={isOpen ? 2 : 0} py={isOpen ? 1.5 : 0}>
            <Button
                variant={isOpen ? 'blueContained' : 'text'}
                startIcon={isOpen ? <SwapHorizRounded /> : <UndoRounded />}
                onClick={handleReviewReplacement}
                fullWidth
                style={{
                    boxShadow: isOpen ? 0 : undefined,
                    color: isOpen ? undefined : theme.palette.subtext.main
                }}
            >
                Review Replacement
            </Button>
        </Stack>
    );
}

export default ReplacementOptimizationActions;
